const zones = {
    'Central': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '58', '59', '77', '78'],
    'East': ['42', '43', '44', '45', '46', '47', '48', '49', '50', '81', '51', '52'],
    'North-East': ['53', '54', '55', '82', '56', '57', '79', '80'],
    'West': ['11', '12', '13', '60', '61', '62', '63', '64', '65', '66', '67', '68'],
    'North': ['69', '70', '71', '72', '73', '75', '76']
}

export default zones